import React, {useState, useRef} from 'react';
import DisplayMetaWithImport from "../components/DisplayMetaWithImport.comp";
import {formatDate} from "../../../utils/utils";

import {
    Assess8_translations
} from "../../../services/metadata.service";
import {Link, useParams} from "react-router-dom";

// name: display on preview top
// key: column# of excel sheet
// json_key: key for posting data to api

const instrument_response_parser = (data) => {
    let str = data.trim();

    // const str_nl_arr = str.split('\n')
    // if (str_nl_arr.length > 1) {
    //     return str_nl_arr;
    // }

    let str_arr = str.split('{{');
    let output = []
    for (let i=1; i<str_arr.length; i++) {
        const option = str_arr[i].split('}}')[0];
        if (option.length >= 1) {
            output.push(option);
        }
    }
    if (output.length === 0) {
        return data
    }
    return output;
}

const additional_json_rendering_of_IR = (json_obj) => {
    if (typeof json_obj['instrument_response'] === 'object') {
        json_obj['instrument_response'] = JSON.stringify(json_obj['instrument_response']);
        json_obj['instrument_response_type'] = 'JSON'
    } else {
        json_obj['instrument_response_type'] = 'STRING'
    }
    return json_obj;
}

const columns = [
    {name: 'Code', key: 0, excel_key: 'code', json_key: 'code', data_key: 'code'},
    {name: 'Locale', key: -1, excel_key: '', json_key: 'locale', data_key: 'locale'},
    {name: 'Instrument Question', key: 1, excel_key: 'Question', json_key: 'instrument_question', data_key: 'instrument_question'},
    {name: 'Q. subtitle Top', key: 2, excel_key: 'subtitle_top', json_key: 'question_subtitle_top', data_key: 'question_subtitle_top'},
    {name: 'Q. subtitle Bottom', key: 3, excel_key: 'subtitle_bottom', json_key: 'question_subtitle_bottom', data_key: 'question_subtitle_bottom'},
    {name: 'Instrument Response', key: 4, excel_key: 'Choices', json_key: 'instrument_response', data_key: 'instrument_response_data', data_parser: instrument_response_parser},
]

const tableCols = [
    {
        label: 'Code',
        field: 'code', sort: 'disabled', width: 150
    },
    {
        label: 'Locale',
        field: 'locale', sort: 'asc', width: 150
    },
    {
        label: 'Instrument Question',
        field: 'instrument_question', sort: 'disabled', width: 150
    },
    {
        label: 'Q. subtitle Top',
        field: 'question_subtitle_top', sort: 'asc', width: 150
    },
    {
        label: 'Q. subtitle Bottom',
        field: 'question_subtitle_bottom', sort: 'asc', width: 150
    },
    {
        label: 'Instrument Response',
        field: 'instrument_response', sort: 'disabled', width: 150
    },
    {
        label: 'Created',
        field: 'createdAt', width: 150
    },
    {
        label: 'Updated',
        field: 'updatedAt', width: 150
    },
    {
        label: 'Actions',
        field: 'actions', sort: 'disabled', searchable: false
    }
]



const Assess8_translationsPage = (props) => {

    const { url_param_str } = useParams();
    const search_query = url_param_str.split('=').length > 1 ? url_param_str.split('=')[1]  : '';

    // --- Server-side pagination state ---
    const [serverPage, setServerPage] = useState(1);
    const [serverLimit, setServerLimit] = useState(10);
    const [serverTotal, setServerTotal] = useState(0);
    const [serverTotalPages, setServerTotalPages] = useState(1);

    // --- Server-side search state ---
    const [serverSearch, setServerSearch] = useState(search_query || '');
    const [debouncedSearch, setDebouncedSearch] = useState(search_query || '');
    const debounceTimer = useRef(null);

    // --- Cache mode state ---
    const [cacheMode, setCacheMode] = useState(false);
    const [cacheData, setCacheData] = useState(null);

    // Debounce search input: 400ms delay before updating debouncedSearch
    const handleServerSearchChange = (newSearch) => {
        setServerSearch(newSearch);
        if (debounceTimer.current) clearTimeout(debounceTimer.current);
        debounceTimer.current = setTimeout(() => {
            setDebouncedSearch(newSearch);
            setServerPage(1); // reset to page 1 on new search
        }, 400);
    };

    // When debouncedSearch changes, the listAPI re-fetch is triggered via the
    // dependency in DisplayMetaWithImport (serverSearch/serverPage/serverLimit effect).

    const fetchPage = async (page, limit, search) => {
        const result = await Assess8_translations.listData(page, limit, search);
        if (result && result.data) {
            const { total, page: pg, limit: lm, total_pages } = result.data;
            // Clamp page if it exceeds total_pages
            const clampedPage = total_pages > 0 && pg > total_pages ? total_pages : pg;
            setServerPage(clampedPage || 1);
            setServerLimit(lm || limit);
            setServerTotal(total || 0);
            setServerTotalPages(total_pages || 1);
            return result;
        }
        return result;
    };

    const handleServerPageChange = (newPage) => {
        setServerPage(newPage);
    };

    const handleServerLimitChange = (newLimit) => {
        setServerPage(1);
        setServerLimit(newLimit);
    };

    const handleExitCacheMode = () => {
        setCacheMode(false);
        setCacheData(null);
    };

    // listAPI called by DisplayMetaWithImport — uses current pagination + search state
    const paginatedListAPI = async () => {
        if (cacheMode && cacheData) {
            // Return the already-loaded cache data (no re-fetch needed)
            return { data: cacheData };
        }
        return fetchPage(serverPage, serverLimit, debouncedSearch);
    };

    const table_row__additional_rendering = (row) => {

        let ir_output = '';
        if (row.instrument_response_type === 'JSON') {
            const ir_data_cp = JSON.parse(row.instrument_response);

            if (Array.isArray(ir_data_cp)) {
                let spans = [];
                for (let item of ir_data_cp) {
                    spans.push(<span className={'meta-data-table-array-span'}>{item}</span>);

                    ir_output += `(${item})`
                    ir_output += '\n'
                }
                row.instrument_response = spans;
            } else {
                row.instrument_response = ir_data_cp;
                ir_output = ir_data_cp;
            }
        } else {
            ir_output = row.instrument_response
        }
        row.instrument_response_data = ir_output;
        const create_data = formatDate(row.createdAt) + ',\n ' + (row.createdBy ? row.createdBy : '');
        row.createdAt = create_data;

        const update_data = formatDate(row.updatedAt) + ',\n ' + (row.updatedBy ? row.updatedBy : '');
        row.updatedAt = update_data;
        return row;
    }

    return (
        <DisplayMetaWithImport
            title={'Assess 8 [Translations]'}
            modal_title={'Assess 8 - Translations Preview'}
            sheet_name={'assess_8_instruments'}
            columns={columns}
            tableCols={tableCols}
            jsonSpRender={additional_json_rendering_of_IR}
            tableSpRender={table_row__additional_rendering}
            search_query={search_query}
            listAPI={paginatedListAPI}
            postAPI={Assess8_translations.postData}
            deleteAPI={Assess8_translations.deleteEntity}
            updateAPI={Assess8_translations.updateEntity}
            preRemoveAPI={Assess8_translations.preRemoveCheck}
            populate_locale={true}
            serverSidePagination={true}
            serverPage={serverPage}
            serverLimit={serverLimit}
            serverTotal={serverTotal}
            serverTotalPages={serverTotalPages}
            onServerPageChange={handleServerPageChange}
            onServerLimitChange={handleServerLimitChange}
            // server-side search
            serverSideSearch={true}
            serverSearch={serverSearch}
            onServerSearchChange={handleServerSearchChange}
            debouncedSearch={debouncedSearch}
            // load all from cache
            loadAllCachedAPI={Assess8_translations.listAllCached}
            cacheMode={cacheMode}
            setCacheMode={setCacheMode}
            setCacheData={setCacheData}
            onExitCacheMode={handleExitCacheMode}
        />
    );
}

export default Assess8_translationsPage;


